import { useEffect, useRef, useState } from "react";
import { useI18n, LANGS, LANG_NAMES } from "../i18n";
import { useLangHref } from "./LangToggle";

/**
 * 지도 헤더의 언어 선택. 지구본 버튼을 누르면 바로 아래로 언어 목록 팝업이 열린다.
 * 바깥을 누르거나 Esc 를 누르면 닫힌다.
 * 언어 전환은 LangToggle 과 같이 <a href> 전체 로드다.
 */
function LangGlobe() {
    const { lang, t } = useI18n();
    const hrefFor = useLangHref();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onPointer = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        const onKey = (e) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("pointerdown", onPointer);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("pointerdown", onPointer);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);

    return (
        <div ref={ref} className={`lang_globe ${open ? "open" : ""}`}>
            <button
                type="button"
                className="lang_globe_btn"
                aria-label={t("언어 선택")}
                aria-haspopup="true"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <svg
                    viewBox="0 0 24 24"
                    width="22"
                    height="22"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    aria-hidden="true"
                >
                    <circle cx="12" cy="12" r="9.2" />
                    <ellipse cx="12" cy="12" rx="4" ry="9.2" />
                    <path d="M3 12h18" />
                </svg>
            </button>
            {open && (
                <ul className="lang_globe_popup">
                    {LANGS.map((code) => (
                        <li key={code}>
                            <a
                                className={lang === code ? "current" : ""}
                                href={hrefFor(code)}
                                hrefLang={code}
                                aria-current={lang === code ? "true" : undefined}
                            >
                                {LANG_NAMES[code]}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default LangGlobe;
